const CDN_HOST_PATTERN = /^https?:\/\/www\.zappyrent\.com/i

export function getUploadImageUrl(src) {
  if (!src) return src

  if (String(src).startsWith('data:')) return src

  const cdnBase =
    process.env.REACT_APP_CDN_URL || process.env.REACT_APP_WEBSITE_PATH

  if (/^https?:\/\//i.test(src) || src.startsWith('//')) {
    return src.replace(CDN_HOST_PATTERN, cdnBase)
  }

  const filename = src.replace(/^\/?uploads\//, '')
  return `${cdnBase}/uploads/${filename}`
}
